import { render, staticRenderFns } from "./PhoneProductCard.vue?vue&type=template&id=6ec3c9f5"
import script from "./PhoneProductCard.vue?vue&type=script&lang=ts"
export * from "./PhoneProductCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports